export const importIcon = (name) => {
	try {
		return require(`../assets/icons/${name}.svg`);
	} catch (e) {
		return '';
	}
};
